<template>
    <router-link tag='tr' :to="{name: 'receivedfilesfile', params: {fileId: file.Id}}" :class="{'is-new': file.IsNew}">
        <td class="main-td-content">
            <div class="inbox-widget d-flex align-items-center">
                <file-icon-comp :fileType="file.FileType"></file-icon-comp>
                <div class="inbox-widget-text d-flex flex-column">
                    <div class="inbox-widget-heading">{{file.Name}}</div>
                    <div class="inbox-widget-sub-heading">Filetype: {{file.FileType}}</div>
                </div>
            </div>
        </td>
        <td class="sub-td-content">
            <font-awesome-icon class="read-icon" :icon="file.IsRead ? ['fad', 'eye'] : ['fad', 'eye-slash']" :class="{ 'is-read': file.IsRead }" fixed-width />
        </td>
        <td class="sub-td-content">
            <font-awesome-icon class="date-icon mr-1" :icon="['fad', 'calendar-alt']" fixed-width />
            {{fileDateAdded}}
        </td>
    </router-link>
</template>
<script>
import FileIconComp from '../file-elements/file-icon'

export default {
    props: {
        file: Object
    },
    components: {
        FileIconComp
    },
    computed: {
        fileDateAdded() {
            return new Date(this.file.DateAdded).toLocaleDateString('en-GB')
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/bootstrap/_custom';

    tr {
        color: #444;
        cursor: pointer;
        &.is-new {
            //background-color: rgba(0,116,217,0.1);
            background-color: theme-color-level(primary, -11.8);
        }
    }
    .main-td-content {
        width: 100%;
    }
    .sub-td-content {
        width: 1%;
        white-space: nowrap;
    }
    .inbox-widget-heading {
        font-size: 1em;
        .is-new & {
            font-weight: 700;
        }
    }

    .inbox-widget-sub-heading {
        font-size: 0.8em;
        color: #444;
        .is-new & {
            font-weight: 700;
        }
    }

    .read-icon {
        color: $danger;
    }

    .read-icon.is-read {
        color: $primary;
    }

    .date-icon {
        color: $primary;
    }

    td {
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-entry.vue